import type { StorefrontSiteConfig } from '@/lib/api'
import { isHexColor, resolveAccessibleTint } from '@/lib/storefront-theme'

const normalizeText = (value: unknown) => String(value ?? '').replace(/\s+/g, ' ').trim()

const normalizeConfiguredColor = (value: unknown, fallback = '') => {
  const normalized = normalizeText(value)
  if (isHexColor(normalized)) return normalized.toLowerCase()
  return fallback
}

const normalizePublicOrigin = (value: unknown) => {
  const normalized = normalizeText(value)
  if (!normalized) return ''

  try {
    const url = new URL(normalized)
    if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password) return ''
    return url.origin
  } catch {
    return ''
  }
}

export const resolveStorefrontSitePresentation = (
  siteConfig: StorefrontSiteConfig | null | undefined
) => {
  const siteName = normalizeText(siteConfig?.nome) || normalizeText(siteConfig?.empresa_nome)
  const primaryColor = normalizeConfiguredColor(siteConfig?.cor_primaria)
  const secondaryColor = normalizeConfiguredColor(siteConfig?.cor_secundaria, primaryColor)
  const launchesColor = normalizeConfiguredColor(siteConfig?.cor_lancamentos, secondaryColor)
  const justArrivedColor = normalizeConfiguredColor(siteConfig?.cor_acabou_chegar, secondaryColor)

  return {
    siteName,
    companyName: normalizeText(siteConfig?.empresa_nome) || siteName,
    seoTitle: normalizeText(siteConfig?.seo_title) || siteName,
    seoDescription: normalizeText(siteConfig?.seo_description),
    publicUrl: normalizePublicOrigin(siteConfig?.storefront_identity?.public_url),
    primaryColor,
    secondaryColor,
    launchesColor,
    justArrivedColor,
    searchBadge: secondaryColor ? resolveAccessibleTint(secondaryColor) : null,
    launchesChip: launchesColor ? resolveAccessibleTint(launchesColor, 0.08) : null,
    justArrivedChip: justArrivedColor ? resolveAccessibleTint(justArrivedColor, 0.08) : null,
  }
}
